import QuantModelTable from "./QuantModelTable";

export default QuantModelTable;
